import { unauthenticatedApi } from "@/lib/api/client";

export async function resendInviteEmail(email: string): Promise<void> {
  await unauthenticatedApi.url("/users/resend-invite").post({ email }).res();
}
